var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabIconCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_7338",
    "data-name": "Group 7338",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 45.145 45.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7336",
    "data-name": "Group 7336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7335",
    "data-name": "Group 7335"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22640",
    "data-name": "Path 22640",
    d: "M16.55,0H3.909A3.913,3.913,0,0,0,0,3.909V16.55a3.913,3.913,0,0,0,3.909,3.909H16.55a3.913,3.913,0,0,0,3.909-3.909V3.909A3.913,3.913,0,0,0,16.55,0Zm.729,16.55a.73.73,0,0,1-.729.729H3.909a.73.73,0,0,1-.729-.729V3.909a.73.73,0,0,1,.729-.729H16.55a.73.73,0,0,1,.729.729V16.55Z",
    fill: "#9797bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22641",
    "data-name": "Path 22641",
    d: "M178.953,0H166.312A3.913,3.913,0,0,0,162.4,3.909V16.55a3.913,3.913,0,0,0,3.909,3.909h12.642a3.913,3.913,0,0,0,3.909-3.909V3.909A3.913,3.913,0,0,0,178.953,0Zm.729,16.55a.73.73,0,0,1-.729.729H166.312a.73.73,0,0,1-.729-.729V3.909a.73.73,0,0,1,.729-.729h12.642a.73.73,0,0,1,.729.729Z",
    transform: "translate(-137.717)",
    fill: "#9797bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22642",
    "data-name": "Path 22642",
    d: "M16.55,162.4H3.909A3.913,3.913,0,0,0,0,166.311v12.642a3.913,3.913,0,0,0,3.909,3.909H16.55a3.913,3.913,0,0,0,3.909-3.909V166.311A3.913,3.913,0,0,0,16.55,162.4Zm.729,16.551a.73.73,0,0,1-.729.729H3.909a.73.73,0,0,1-.729-.729V166.311a.73.73,0,0,1,.729-.729H16.55a.73.73,0,0,1,.729.729v12.642Z",
    transform: "translate(0 -137.717)",
    fill: "#9797bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22643",
    "data-name": "Path 22643",
    d: "M178.953,162.4H166.312a3.913,3.913,0,0,0-3.909,3.909v12.642a3.913,3.913,0,0,0,3.909,3.909h12.642a3.913,3.913,0,0,0,3.909-3.908V166.311A3.913,3.913,0,0,0,178.953,162.4Zm.729,16.551a.73.73,0,0,1-.729.729H166.312a.73.73,0,0,1-.729-.729V166.311a.73.73,0,0,1,.729-.729h12.642a.73.73,0,0,1,.729.729Z",
    transform: "translate(-137.717 -137.717)",
    fill: "#9797bd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabIconCard);
export default __webpack_public_path__ + "static/media/TabIconCard.8ee0afa0efbe5432b6725ff48235c481.svg";
export { ForwardRef as ReactComponent };